import { render, staticRenderFns } from "./warrantyClass.vue?vue&type=template&id=89538438&"
import script from "./warrantyClass.vue?vue&type=script&lang=js&"
export * from "./warrantyClass.vue?vue&type=script&lang=js&"
import style0 from "./warrantyClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports